export const governmentInspectionGuidePageConstants = {
    headerText: '검사 안내',
};
